/**
 *   [GLOBAL] Index LIST
 */
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_INS_INFO = "UPDATE_USER_INS_INFO"; //更新用户的信息
export const UPDATE_USER_INS_POST = "UPDATE_USER_INS_POST";
export const NEED_UPDATE_USER_INS_POST = "NEED_UPDATE_USER_INS_POST";
export const DELETE_USER = "DELETE_USER"; //登出用户
export const CLEAR_LOGIN_USER = "CLEAR_LOGIN_USER"; //登出登陆的用户
export const CLEAR_ALL_USER = "CLEAR_ALL_USER"; //登出所有的用户
export const CLEAR_INS_USER = "CLEAR_INS_USER"; //清除所有ins相关信息
export const LOGIN_BY_FB = "LOGIN_BY_FB"; //通过facebook登陆
export const CHANGE_CURRENT_USER = "CHANGE_CURRENT_USER"; //改变当前的INS USER ID
export const CHANGE_CURRENT_INS_POST_ID = "CHANGE_CURRENT_INS_POST_ID"; //改变当前的INS MEDIA ID
export const CHANGE_CURRENT_INS_VIEW_ID = "CHANGE_CURRENT_INS_VIEW_ID";
export const UPDATE_DEVICE_ID = "UPDATE_DEVICE_ID"; //更新设备Id
export const UPDATE_INTERFACE_EXIST_STATE = "UPDATE_INTERFACE_EXIST_STATE";
export const UPDATE_NATIVE_LOGIN_STATUS = "UPDATE_NATIVE_LOGIN_STATUS"; //告诉原生masterId和是否是登陆状态
export const UPDATE_USER_LIST = "UPDATE_USER_LIST"; // 修改信息后单个更新用户列表
export const TRANSFER_MASTER_ID_TO_IDFA = "TRANSFER_MASTER_ID_TO_IDFA"; //转移用户
export const GETTER_IDFA = "GETTER_IDFA"; //idfa
export const GETTER_IDFV = "GETTER_IDFV"; //idfv

//[getter]:
export const GETTER_USER_LIST = "GETTER_USER_LIST"; //获取用户的列表
export const GETTER_EARN_COIN_USER_LIST = "GETTER_EARN_COIN_USER_LIST";
export const GETTER_DEVICE_ID = "GETTER_DEVICE_ID"; //获取到设备的ID
export const GETTER_LOGIN_FIRST_USER = "GETTER_LOGIN_FIRST_USER"; //获取第一个登陆的用户信息
export const GETTER_USER_LACK_PROFILE_OR_POST =
  "GETTER_USER_LACK_PROFILE_OR_POST";
export const GETTER_JUDGE_INTERFACE_EXIST = "GETTER_JUDGE_INTERFACE_EXIST";
export const CAMERA_AND_ALBUM_ENABLED = "CAMERA_AND_ALBUM_ENABLED";
export const WATCH_VIDEO = "WATCH_VIDEO";
export const REQUEST_ADMOB_AVAILABLE = "REQUEST_ADMOB_AVAILABLE";

/**
 *      [GX] SETTING DATA 配置信息
 */
export const REQUEST_GX_SETTING_DATA = "REQUEST_GX_SETTING_DATA";
export const RECEIVE_GX_SETTING_DATA = "RECEIVE_GX_SETTING_DATA";
export const UPDATE_CRUCIAL_SETTING_KEY = "UPDATE_CRUCIAL_SETTING_KEY";
export const UPDATE_LOCALIZE_PRICE = "UPDATE_LOCALIZE_PRICE";
//[getter]
export const GETTER_SEARCH_LITE_MODE = "GETTER_SEARCH_LITE_MODE";
export const GETTER_LOCALIZE_PRICE = "GETTER_LOCALIZE_PRICE";
export const GETTER_LOCALIZE_PRICE_DATA = "GETTER_LOCALIZE_PRICE_DATA";
export const GETTER_SERVICE_OFFER = "GETTER_SERVICE_OFFER";
export const GETTER_SETTING_BOUGHT_VIP = "GETTER_SETTING_BOUGHT_VIP";

export const GETTER_SPECIAL_COINS = "GETTER_SPECIAL_COINS"; // 获取特殊类型的COINS
export const GETTER_SPECIAL_OFFER_CONTROL = "GETTER_SPECIAL_OFFER_CONTROL";
export const GETTER_PRO_EXTRA_PERCENTAGE = "GETTER_PRO_EXTRA_PERCENTAGE";

export const GETTER_APP_TAKE_DOWN = "GETTER_APP_TAKE_DOWN"; // 获取当前app是否已经下架
export const GETTER_TAKE_DOWN_OPERATE_NUMS = "GETTER_TAKE_DOWN_OPERATE_NUMS"; // app下架后调起payment的次数
export const UPDATE_TAKE_DOWN_UPDATE_NUMS = "UPDATE_TAKE_DOWN_UPDATE_NUMS"; // 改变app下架后掉起payment的次数
export const GETTER_IS_HAPPY_HOUR = "GETTER_IS_HAPPY_HOUR"; //happy hour
export const GETTER_DOUBLE_COINS_PERCENTAGE = "GETTER_DOUBLE_COINS_PERCENTAGE";

export const GETTER_VIP_OFFERS = "GETTER_VIP_OFFERS";
export const GETTER_SETTING_FREE_FOLLOWERS_ENABLE =
  "GETTER_SETTING_FREE_FOLLOWERS_ENABLE"; // 获取boss上关于是否允许赠送followers的开关
export const REQUEST_FREE_FOLLOWERS = "REQUEST_FREE_FOLLOWERS"; // 获取boss上关于是否允许赠送followers的开关
export const GETTER_BIG_PRICE_LIST = "GETTER_BIG_PRICE_LIST";
export const GETTER_FEATURES_ITEM_BY_FUNCTION =
  "GETTER_FEATURES_ITEM_BY_FUNCTION";

//superpay
export const GETTER_SUPER_PAY_SETTING_PARAMS_VALID =
  "GETTER_SUPER_PAY_SETTING_PARAMS_VALID";
export const GETTER_SUPER_PAY_PARAMS = "GETTER_SUPER_PAY_PARAMS";
export const GETTER_SUPER_PAY_DESC = "GETTER_SUPER_PAY_DESC";
export const GETTER_SUPER_PAY_LAUNCH_DESC = "GETTER_SUPER_PAY_LAUNCH_DESC";
//back up
export const GETTER_BACK_UP_APP_SETTING_PARAMS_VALID =
  "GETTER_BACK_UP_APP_SETTING_PARAMS_VALID";
export const GETTER_BACK_UP_APP_PARAMS = "GETTER_BACK_UP_APP_PARAMS";
export const GETTER_BACK_UP_APP_DESC = "GETTER_BACK_UP_APP_DESC";
export const GETTER_BACK_UP_APP_LAUNCH_DESC = "GETTER_BACK_UP_APP_LAUNCH_DESC";

/**
 *  初始化
 */
export const INITIAL_ROUTE_TO_MAIN_TAB = "INITIAL_ROUTE_TO_MAIN_TAB";
export const INITIAL_SETTING = "INITIAL_SETTING";
export const INITIAL_HANDLE_ROUTER = "INITIAL_HANDLE_ROUTER";
export const INITIAL_HANDLE_ROUTER_NOTICE = "INITIAL_HANDLE_ROUTER_NOTICE";
export const INITIAL_HANDLE_NOTICE = "INITIAL_HANDLE_NOTICE";

//  SUPER PAY
export const UPDATE_SUPER_PAY_APP_CONFIG = "UPDATE_SUPER_PAY_APP_CONFIG";
export const UPDATE_SUPER_PAY_APP_INSTALLED_STATUS =
  "UPDATE_SUPER_PAY_APP_INSTALLED_STATUS";
export const UPDATE_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE =
  "UPDATE_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE"; //是否能用config的接口
export const UPDATE_SUPER_PAY_WAY_INTERFACE_ENABLE =
  "UPDATE_SUPER_PAY_WAY_INTERFACE_ENABLE"; //是否可以支付
export const CHECK_SUPER_PAY_APP_CAN_SHOW = "CHECK_SUPER_PAY_APP_CAN_SHOW";
export const CHECK_SUPER_PAY_APP_CONFIG_ENABLE =
  "CHECK_SUPER_PAY_APP_CONFIG_ENABLE";
export const CHECK_SUPER_PAY_APP_INSTALLED = "CHECK_SUPER_PAY_APP_INSTALLED";
export const REQUEST_SUPER_PAY_APP_CONFIG = "REQUEST_SUPER_PAY_APP_CONFIG";
export const GETTER_SUPER_PAY_APP_CONFIG = "GETTER_SUPER_PAY_APP_CONFIG";
export const START_INSTALL_SUPER_PAY_APP = "START_INSTALL_SUPER_PAY_APP";
export const GETTER_SUPER_PAY_SHOW_ENABLE = "GETTER_SUPER_PAY_SHOW_ENABLE";
export const UPDATE_SUPER_PAY_SHOW_ENABLE = "UPDATE_SUPER_PAY_SHOW_ENABLE";
export const SHOW_SUPER_PAY_BUBBLE = "SHOW_SUPER_PAY_BUBBLE";
export const CHECK_SUPER_PAY_WAY_CAN_USE = "CHECK_SUPER_PAY_WAY_CAN_USE";
export const CHECK_PRODUCT_IAP_VALID = "CHECK_PRODUCT_IAP_VALID";
export const PAY_BY_SUPER_PAY = "PAY_BY_SUPER_PAY";
export const SUPER_PAY_RESULT_PROCESS = "SUPER_PAY_RESULT_PROCESS";
export const SUPER_PAY_TOAST_OR_REDIRECT_TOAST =
  "SUPER_PAY_TOAST_OR_REDIRECT_TOAST";
export const TAKE_DOWN_SHOW_BACK_UP_TOAST = "TAKE_DOWN_SHOW_BACK_UP_TOAST";
export const GETTER_SUPER_PAY_APP_HAS_INSTALLED =
  "GETTER_SUPER_PAY_APP_HAS_INSTALLED";
export const GETTER_SUPER_PAY_APP_INSTALLED_STATUS =
  "GETTER_SUPER_PAY_APP_INSTALLED_STATUS";
export const GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION =
  "GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION";
export const GETTER_SUPER_PAY_PAYMENT_CLOSE_SHOW_RETAIN_ENABLE =
  "GETTER_SUPER_PAY_PAYMENT_CLOSE_SHOW_RETAIN_ENABLE";
export const GETTER_SUPER_PAY_PAYMENT_IAP_CANCEL_DIALOG_ENABLE =
  "GETTER_SUPER_PAY_PAYMENT_IAP_CANCEL_DIALOG_ENABLE";
export const GETTER_SUPER_PAY_SWITCH_TO_IAP_DIALOG_SHOW_ENABLE =
  "GETTER_SUPER_PAY_SWITCH_TO_IAP_DIALOG_SHOW_ENABLE";
export const GETTER_SUPER_PAY_PAY_RESULT_PAGE_CLOSE_SHOW_ENABLE =
  "GETTER_SUPER_PAY_PAY_RESULT_PAGE_CLOSE_SHOW_ENABLE";
export const GETTER_SUPER_PAY_PAY_RESULT_PAGE_SHOW_ENABLE =
  "GETTER_SUPER_PAY_PAY_RESULT_PAGE_SHOW_ENABLE";
export const GETTER_SUPER_PAY_PAY_LAUNCH_SHOW_ENABLE =
  "GETTER_SUPER_PAY_PAY_LAUNCH_SHOW_ENABLE";
export const SWITCH_FRONT_BACK_TO_CHECK_SUPER_PAY_INSTALL_STATUS =
  "SWITCH_FRONT_BACK_TO_CHECK_SUPER_PAY_INSTALL_STATUS";
export const SWITCH_FRONT_BACK_TO_CHECK_BACK_UP_INSTALL_STATUS =
  "SWITCH_FRONT_BACK_TO_CHECK_BACK_UP_INSTALL_STATUS";
export const GETTER_SUPER_PAY_PAYMENT_SHOW_ENABLE =
  "GETTER_SUPER_PAY_PAYMENT_SHOW_ENABLE";
// [BACK_UP]

//getters
export const GETTER_BACK_UP_APP_CONFIG = "GETTER_BACK_UP_APP_CONFIG";
export const GETTER_BACK_UP_APP_SHOW_ENABLE = "GETTER_BACK_UP_APP_SHOW_ENABLE";
export const GETTER_BACK_UP_APP_HAS_INSTALLED =
  "GETTER_BACK_UP_APP_HAS_INSTALLED";
export const GETTER_BACK_UP_APP_INSTALLED_STATUS =
  "GETTER_BACK_UP_APP_INSTALLED_STATUS";
export const GETTER_BACK_UP_APP_SHOW_OTHER_CONDITION =
  "GETTER_BACK_UP_APP_SHOW_OTHER_CONDITION";
export const GETTER_BACK_UP_DELIVER_CLOSE_TOAST_SHOW_ENABLE =
  "GETTER_BACK_UP_DELIVER_CLOSE_TOAST_SHOW_ENABLE";
export const GETTER_BACK_UP_DELIVER_RECOMMEND_SHOW_ENABLE =
  "GETTER_BACK_UP_DELIVER_RECOMMEND_SHOW_ENABLE";
export const GETTER_BACK_UP_PAY_RESULT_PAGE_CLOSE_SHOW_ENABLE =
  "GETTER_BACK_UP_PAY_RESULT_PAGE_CLOSE_SHOW_ENABLE";
export const GETTER_BACK_UP_APP_LAUNCH_SHOW_ENABLE =
  "GETTER_BACK_UP_APP_LAUNCH_SHOW_ENABLE";
export const GETTER_BACK_UP_PAY_RESULT_PAGE_SHOW_ENABLE =
  "GETTER_BACK_UP_PAY_RESULT_PAGE_SHOW_ENABLE";
export const GETTER_SUPER_PAY_APP_DESC = "GETTER_SUPER_PAY_APP_DESC";
export const GETTER_SUPER_PAY_APP_DESC_LIST = "GETTER_SUPER_PAY_APP_DESC_LIST";
export const GETTER_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE =
  "GETTER_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE";
//mutations
export const UPDATE_BACK_UP_APP_CONFIG = "UPDATE_BACK_UP_APP_CONFIG";
export const UPDATE_BACK_UP_APP_CONFIG_INTERFACE_ENABLE =
  "UPDATE_BACK_UP_APP_CONFIG_INTERFACE_ENABLE";
export const UPDATE_BACK_UP_APP_INSTALLED_STATUS =
  "UPDATE_BACK_UP_APP_INSTALLED_STATUS";
export const UPDATE_BACK_UP_APP_PAY_WAY_INTERFACE_ENABLE =
  "UPDATE_BACK_UP_APP_PAY_WAY_INTERFACE_ENABLE";
export const UPDATE_BACK_UP_APP_SHOW_ENABLE = "UPDATE_BACK_UP_APP_SHOW_ENABLE";
//actions:
export const CHECK_BACK_UP_APP_CAN_SHOW = "CHECK_BACK_UP_APP_CAN_SHOW";
export const CHECK_BACK_UP_PAY_WAY_CAN_USE = "CHECK_BACK_UP_PAY_WAY_CAN_USE";
export const START_INSTALL_BACK_UP_APP = "START_INSTALL_BACK_UP_APP";
export const REQUEST_BACK_UP_APP_CONFIG = "REQUEST_BACK_UP_APP_CONFIG";
export const CHECK_BACK_UP_APP_INSTALLED = "CHECK_BACK_UP_APP_INSTALLED";
export const CHECK_BACK_UP_APP_CONFIG_ENABLE =
  "CHECK_BACK_UP_APP_CONFIG_ENABLE";
/**
 *      [GX] MASTER SERVER DATA  获取gx的主账号Info
 */
export const UPDATE_GX_MASTER_SERVER_DATA = "UPDATE_GX_MASTER_SERVER_DATA";
export const UPDATE_GX_SERVICE_LIST = "UPDATE_GX_SERVICE_LIST";
export const LOGIN_BY_GX = "LOGIN_BY_GX"; //gx服务器的login
export const LINK_ACCOUNT = "LINK_ACCOUNT"; //关联账户
export const TRANSFER_ACCOUNT = "TRANSFER_ACCOUNT"; //转移vip
export const ADD_CONNECTED_USER = "ADD_CONNECTED_USER"; //增加挂链的用户上去
export const ADD_OTHER_APP_USER = "ADD_OTHER_APP_USER"; //增加挂链的用户上去
export const RECEIVE_GX_MASTER_SERVER_DATA = "RECEIVE_GX_MASTER_SERVER_DATA";
export const DELETE_EXTRA_PROPERTY = "DELETE_EXTRA_PROPERTY"; // 如果gxUserInfo某些信息后台没传,需要手动更新的情况
export const REFRESH_USERINFO_DATA = "REFRESH_USERINFO_DATA"; // 更新账户信息
export const RECEIVE_GX_SERVICE_LIST = "RECEIVE_GX_SERVICE_LIST"; // 获取当前登录所有的订阅内容
export const DISCONNECT_USER = "DISCONNECT_USER"; //取消关联用户
export const UPDATE_FREE_FOLLOWERS_ENABLE_STATE =
  "UPDATE_FREE_FOLLOWERS_ENABLE_STATE"; //更新本地开关，不允许执行赠送followers逻辑
export const GETTER_NATIVE_FREE_FOLLOWERS_ENABLE =
  "GETTER_FREE_FOLLOWERS_ENABLE"; // 本地开关，是否允许执行赠送followers逻辑
export const CHECK_GX_USER_LOGINED = "CHECK_GX_USER_LOGINED";
//[getter]:
export const GETTER_MASTER_ID = "GETTER_MASTER_ID"; //获取主账号的id
export const GETTER_MASTER_COINS = "GETTER_MASTER_COINS"; //获取主账户的金币数量
export const GETTER_MASTER_SERVICE_DATA = "GETTER_MASTER_SERVICE_DATA";
export const GETTER_SERVICE_LIST = "GETTER_SERVICE_LIST"; // 获取所有订阅类型
export const GETTER_SUBS_LIST = "GETTER_SUBS_LIST"; // 获取处理过的订阅类型的数据列表
export const RECEIVE_SUBS_LIST = "RECEIVE_SUBS_LIST"; // 同步处理订阅列表数据
export const GETTER_VIP_VALID_COUNT = "GETTER_VIP_VALID_COUNT";
export const UPDATE_VIP_PACKAGE_PROPERTY = "UPDATE_VIP_PACKAGE_PROPERTY";
export const GETTER_RECOMMEND_OFFER = "GETTER_RECOMMEND_OFFER";
export const GETTER_CURRENT_OFFER = "GETTER_CURRENT_OFFER";

/**
 *      [INS] INS_USER_INFO_PROFILE 获取ins的info
 */
export const REQUEST_INS_USER_INFO_DATA = "REQUEST_INS_USER_INFO_DATA";
export const RECEIVE_INS_USER_INFO_DATA = "RECEIVE_INS_USER_INFO_DATA";
export const MERGE_INS_USER_INFO_DATA = "MERGE_INS_USER_INFO_DATA";
//[getter]:
export const GETTER_CURRENT_INS_USER_INFO = "GETTER_CURRENT_INS_USER_INFO"; //当前的ins user Info
export const GETTER_CURRENT_INS_POST_ID = "GETTER_CURRENT_INS_POST_ID"; //当前的ins media id
export const GETTER_CURRENT_INS_VIEW_ID = "GETTER_CURRENT_INS_VIEW_ID"; //当前的ins media id
export const GETTER_CURRENT_INS_USER_ID = "GETTER_CURRENT_INS_USER_ID"; //当前的ins user id
export const GETTER_CURRENT_INS_MEDIA_INFO = "GETTER_CURRENT_INS_MEDIA_INFO"; //当前的ins user media info
export const GETTER_CURRENT_INS_MEDIA_LIST_INFO =
  "GETTER_CURRENT_INS_MEDIA_LIST_INFO"; //获取当前用户的Media List总的info
export const GETTER_INS_MEDIA_INFO_BY_ID = "GETTER_INS_MEDIA_INFO_BY_ID"; //获取当前单个Media的Info
export const GETTER_INS_USER_INFO_BY_ID = "GETTER_INS_USER_INFO_BY_ID";
export const GETTER_INS_LOGIN_USER_ID = "GETTER_INS_LOGIN_USER_ID";
export const SHOW_LITE_SEARCH_OR_LOGIN = "SHOW_LITE_SEARCH_OR_LOGIN";
/**
 *      [INS] INS_USER_MEDIA_LIST_DATA  获取meidia_list
 */
export const REQUEST_INS_USER_MEDIA_LIST_DATA =
  "REQUEST_INS_USER_MEDIA_LIST_DATA";
export const RECEIVE_INS_USER_MEDIA_LIST_DATA =
  "RECEIVE_INS_USER_MEDIA_LIST_DATA";
export const REQUEST_INS_USER_MEDIA_LIST_DATA_MORE =
  "REQUEST_INS_USER_MEDIA_LIST_DATA_MORE"; //请求下一页
export const RECEIVE_INS_USER_MEDIA_LIST_DATA_MORE =
  "RECEIVE_INS_USER_MEDIA_LIST_DATA_MORE"; //接受下一页
export const UPDATE_INS_USER_MEDIA_LIST_MORE_AVAILABLE_TAGS =
  "UPDATE_INS_USER_MEDIA_LIST_MORE_AVAILABLE_TAGS";
export const UPDATE_INS_USER_MEDIA_LIST_MAX_MEDIA_ID =
  "UPDATE_INS_USER_MEDIA_LIST_MAX_MEDIA_ID";
export const UPDATE_POST_DISABLE_COMMENT = "UPDATE_POST_DISABLE_COMMENT";
export const ENABLE_POST_COMMENT = "ENABLE_POST_COMMENT";
//getters:
export const GETTER_CURRENT_INS_MEDIA_MORE_AVAILABLE_TAGS =
  "GETTER_CURRENT_INS_MEDIA_MORE_AVAILABLE_TAGS";
export const GETTER_CURRENT_INS_MEDIA_MAX_MEDIA_ID =
  "GETTER_CURRENT_INS_MEDIA_MAX_MEDIA_ID";
/**
 *      [INS] INS_COOKIE_MANAGER  cookie的管理
 */
export const UPDATE_INS_COOKIE_BY_USER_ID = "UPDATE_INS_COOKIE_BY_USER_ID";
export const DELETE_INS_COOKIE_BY_USER_ID = "DELETE_INS_COOKIE_BY_USER_ID";
export const CLEAR_ALL_INS_COOKIE = "CLEAR_ALL_INS_COOKIE";
//[getter]:
export const GETTER_COOKIE_BY_USER_ID = "GETTER_COOKIE_BY_USER_ID"; //通过user_id找到他的cookie string
export const GETTER_CROS_TOKEN_BY_USER_ID = "GETTER_CROS_TOKEN_BY_USER_ID"; //通过user_id找到他的crostoken
export const GETTER_MASTER_COOKIE = "GETTER_MASTER_COOKIE";

/**
 *   [GX] PAY MENT  支付
 */
export const PAY_BY_IAP = "PAY_BY_IAP";
export const PAY_BY_CARD = "PAY_BY_CARD";
export const PAY_BY_PAY_PAL = "PAY_BY_PAY_PAL";
export const PAY_BY_COIN = "PAY_BY_COIN";
export const PAY_BY_ANY = "PAY_BY_ANY";
export const PAY_BY_CREDIT_CARD = "PAY_BY_CREDIT_CARD";
export const PAYMENT_ERROR_TOAST_HANDLE = "PAYMENT_ERROR_TOAST_HANDLE";
export const PAYMENT_NET_ERROR_HANDLE = "PAYMENT_NET_ERROR_HANDLE";
export const PAYMENT_RETRY_AGAIN = "PAYMENT_RETRY_AGAIN";
export const ADD_FAILED_OFFER = "ADD_FAILED_OFFER";
export const DELETE_FAILED_OFFER = "DELETE_FAILED_OFFER"; //删除历史的失败订单

export const GETTER_FAILED_OFFER = "GETTER_FAILED_OFFER"; //获取到失败的订单
export const UPDATE_RECOMMEND_ORDER_STATUS = "UPDATE_RECOMMEND_ORDER_STATUS";
export const GETTER_RECOMMEND_ORDER_STATUS = "GETTER_RECOMMEND_ORDER_STATUS";
/**
 *   [GX] CASINO 赌场：
 */
export const REQUEST_CASINO = "REQUEST_CASINO";
export const WATCH_CASINO_VIDEO = "WATCH_CASINO_VIDEO";
export const REDEEM_REWARD = "REDEEM_REWARD";
export const GETTER_CASINO_ENABLED = "GETTER_CASINO_ENABLED";
export const GETTER_CASINO_REMAIN_AND_DEAD_LINE =
  "GETTER_CASINO_REMAIN_AND_DEAD_LINE";
export const GETTER_CASINO_CONFIG_AND_LIMIT = "GETTER_CASINO_CONFIG_AND_LIMIT";
export const GETTER_CASINO_REWARD_LIST = "GETTER_CASINO_REWARD_LIST";
export const GETTER_CASINO_HIGHEST_REWARD = "GETTER_CASINO_HIGHEST_REWARD ";
export const ACTION_SHOW_OUT_OF_COIN_DIALOG = "ACTION_SHOW_OUT_OF_COIN_DIALOG";
export const GETTER_CASINO_TAB_INDEX = "GETTER_CASINO_TAB_INDEX";
export const CHNAGE_CASINO_TIPS_STATE = "CHNAGE_CASINO_TIPS_STATE";
export const GETTER_TIPS_STATE = "GETTER_TIPS_STATE";
export const GETTER_CASINO_DEADLINE_BY_NAME = "GETTER_CASINO_DEADLINE_BY_NAME";
/**
 *  Payment 关联的数据
 */
export const UPDATE_APP_LAUNCH_TIME = "UPDATE_APP_LAUNCH_TIME"; //更新app启动的次数
export const UPDATE_FIRST_USE_TIMESTAMP = "UPDATE_FIRST_USE_TIMESTAMP"; // 首次启动的时间戳
export const GETTER_FIRST_ENTER_TIMESTAMP = "GETTER_FIRST_ENTER_TIMESTAMP"; // 获取首次启动的时间戳
export const UPDATE_PURCHASED_TIME = "UPDATE_PURCHASED_TIME"; //更新购买过的次数
export const ADD_PURCHASED_OFFER = "ADD_PURCHASED_OFFER"; //购买过哪些offer
export const UPDATE_PAYMENT_SWITCH_THRESHOLD =
  "UPDATE_PAYMENT_SWITCH_THRESHOLD"; //开关的阈值
export const UPDATE_LAST_SPECIAL_PURCHASED = "UPDATE_LAST_SPECIAL_PURCHASED";
export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS";
export const UPDATE_PRODUCT_DELIVED_DIALOG_APPEAR_TIME =
  "UPDATE_PRODUCT_DELIVED_DIALOG_APPEAR_TIME";
export const JUDGE_CAN_ENTER_PAYMENT = "JUDGE_CAN_ENTER_PAYMENT";

// Getters:
export const GETTER_APP_LAUNCH_TIME = "GEETER_APP_LAUNCH_TIME"; //获取app启动的次数(可以用来判断是否是首次下载之后的启动)
export const GETTER_PURCHASED_OFFER = "GETTER_PURCHASED_OFFER"; //购买过的offer列表
export const GETTER_PURCHASED_VIPPACKAGEOFFER =
  "GETTER_PURCHASED_VIPPACKAGEOFFER"; //购买过的vippackageoffer列表
export const GETTER_LAST_SPECIAL_PURCHASED = "GETTER_LAST_SPECIAL_PURCHASED";
export const GETTER_ORDER_STATUS = "GETTER_ORDER_STATUS";
// export const ADD_PURCHASED_VIP_PACKAGE_OFFER =
//   "ADD_PURCHASED_VIP_PACKAGE_OFFER"; //购买过的vippackageoffer列表
export const GETTER_PURCHASED_TIME = "GETTER_PURCHASED_TIME"; //获取某个类型的购买次数
export const GETTER_PAYMENT_SWITCH_THRESHOLD =
  "GETTER_PAYMENT_SWITCH_THRESHOLD"; //获取开关的阈值
export const GETTER_PRODUCTID_VALID = "GETTER_PRODUCTID_VALID"; // 判断当前的Product_id在iap支付下的有效性
export const GETTER_PRODUCT_DELIVED_DIALOG_APPEAR_TIME =
  "GETTER_PRODUCT_DELIVED_DIALOG_APPEAR_TIME";

/**
 *  [GX INS] EARN COINS
 */
export const REQUEST_FEEDS = "REQUEST_FEEDS"; //请求feed
export const GET_FEEDS = "GET_FEEDS"; //获取feed 更新store
export const ACT_FEED = "ACT_FEED"; //更新feed指向的index
export const SKIP_FEED = "SKIP_FEED"; //跳过当前的feed
export const ACCOUNT_LIMIT_PROCESS = "ACCOUNT_LIMIT_PROCESS"; //账号限制流程
export const ACCOUNT_LIMIT_CHECK = "ACCOUNT_LIMIT_CHECK"; //用户的check检查
export const ACCOUNT_LIMIT_TRIGGER = "ACCOUNT_LIMIT_TRIGGER"; //触发了限制状态
export const EARN_COINS_CHECK = "EARN_COINS_CHECK"; //earn 之前的check
export const INSERT_FEED_OFFER = "INSERT_FEED_OFFER"; //插入feed offer
export const REPLACE_VIP_OFFER_FEED = "REPLACE_VIP_OFFER_FEED"; //替换掉池子中的vip feed
export const REPLACE_SUPER_PAY_OFFER_FEED = "REPLACE_SUPER_PAY_OFFER_FEED";
export const REPLACE_BACK_UP_OFFER_FEED = "REPLACE_BACK_UP_OFFER_FEED";
export const FILTER_FEEDS = "FILTER_FEEDS"; //过滤feeds,例如feed offer
//[getter:]
export const GETTER_CURRENT_FEED = "GETTER_CURRENT_FEED"; //获取当前的feed
export const GETTER_VALID_USER_STATUS = "GETTER_VALID_USER_STATUS";
export const GETTER_USER_STATUS_BY_ID = "GETTER_USER_STATUS_BY_ID";
export const GETTER_USER_STATUS_LIST = "GETTER_USER_STATUS_LIST";
export const GETTER_RETRY_FEED_OFFER = "GETTER_RETRY_FEED_OFFER";
export const GETTER_RANDOM_FEED_OFFER = "GETTER_RANDOM_FEED_OFFER";
export const GETTER_EARN_COINS_GREEN_LIGHT = "GETTER_EARN_COINS_GREEN_LIGHT";
//判断是否支持earn coins的权重
export const GETTER_EARN_COIN_FEED = "GETTER_EARN_COIN_FEED";

/**
 *  [GX] USER STATUS
 */
export const ADD_USER_STATUS = "ADD_USER_STATUS"; //新增了某个用户的状态
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS"; //更新用户的当前状态
export const DELETE_USER_STATUS = "DELETE_USER_STATUS"; //删除某个用户的状态

/**
 *  ROUTER
 */
export const ROUTER_PUSH = "ROUTER_PUSH"; //前进一页
export const ROUTER_GO_BACK = "ROUTER_GO_BACK"; //返回上一页
export const ROUTER_REPLACE = "ROUTER_REPLACE"; //替换当前页的历史记录
export const CHANGE_ROUTER_QUERY = "CHANGE_ROUTER_QUERY"; //change cache of params or query;

//getters:

export const GETTER_ROUTER_STACK_INCLUDE_NAME =
  "GETTER_ROUTER_STACK_INCLUDE_NAME"; //判断路由栈内包含某个路由
export const GETTER_ROUTER_STACK_INCLUDE_TIMES =
  "GETTER_ROUTER_STACK_INCLUDE_TIMES"; //判断路由栈内包含包含某个路由的次数
export const GETTER_ROUTER_STACK = "GETTER_ROUTER_STACK"; //获取路由栈

/**
 * Diolog弹窗
 */
export const DIALOG_SHOW = "DIALOG_SHOW"; //dialog
export const DIALOG_HIDE = "DIALOG_HIDE"; //dialog
export const CASINO_DIALOG_SHOW = "CASINO_DIALOG_SHOW"; //casino dialog
export const CASINO_DIALOG_USE = "CASINO_DIALOG_USE"; // casino更适合业务场景的封装
export const ACTOIN_SHEET_SHOW = "ACTOIN_SHEET_SHOW"; //action sheet show
export const LITE_SEARCH_POP_SHOW = "LITE_SEARCH_POP_SHOW"; //lite search pop
export const LITE_SEARCH_POP_SHOW_STATUS = "LITE_SEARCH_POP_SHOW_STATUS";
export const VIP_RETAIN_DIALOG_SHOW = "VIP_RETAIN_DIALOG_SHOW";
export const VIP_RETAIN_DIALOG_CHANGE = "VIP_RETAIN_DIALOG_CHANGE";
export const DIALOG_SHOW_NEWBIE_FREE_FOLLOW = "DIALOG_SHOW_NEWBIE_FREE_FOLLOW";
export const DIALOG_SHOW_LOGIN_REQUIRED = "DIALOG_SHOW_LOGIN_REQUIRED";

//============================ [GETTER] =================================

export const GETTER_SETTING_DATA = "GETTER_SETTING_DATA"; //获取配置信息
export const GETTER_INFO_BY_OFFER_DATA = "GETTER_INFO_BY_OFFER_DATA"; //通过传入的offer来获取各类信息
export const GETTER_TYPE_OF_SUBS = "GETTER_TYPE_OF_SUBS"; //通过传入offer判断是订阅类型还是普通类型
export const GETTER_CAN_SHOW_VIP_NAV = "GETTER_CAN_SHOW_VIP_NAV"; //判断是否可以在payment页面显示vipNav

export const INITIAL_TIME_STAMP = "INITIAL_TIME_STAMP"; //获取启动时间戳

export const UPDATE_BUYNUM = "UPDATE_BUYNUM"; //记录VIPPACKAGE购买次数

export const GETTER_VIP_TOTAL_COUNT = "GETTER_VIP_TOTAL_COUNT";
export const GETTER_PAYPAL_PRICE_DESC = "GETTER_PAYPAL_PRICE_DESC";

/*
 * 展示doubleCoins或者halfCoins
 * */
export const SHOW_SPECIAL_COINS = "SHOW_SPECIAL_COINS";
export const SHOW_REDIRECT = "SHOW_REDIRECT"; // 展示导量弹窗逻辑
export const SHOW_VIP_CENTER = "SHOW_VIP_CENTER"; // 展示vip弹窗逻辑
export const SHOW_FREE_FOLLOWERS = "SHOW_FREE_FOLLOWERS"; // 展示free_followers弹窗逻辑
export const UPDATE_DOUBLE_COIN_BUBBLE_STATUS =
  "UPDATE_DOUBLE_COIN_BUBBLE_STATUS"; //更新double coin汽包状态
export const GETTER_DOUBLE_COIN_BUBBLE_STATUS =
  "GETTER_DOUBLE_COIN_BUBBLE_STATUS"; //获取double coin汽包状态
export const UPDATE_LIMITED_COIN_SHOW = "UPDATE_LIMITED_COIN_SHOW";
export const GETTER_LIMITED_COIN_SHOW = "GETTER_LIMITED_COIN_SHOW";
export const UPDATE_LIMITED_COIN_INTERVAL_TIME =
  "UPDATE_LIMITED_COIN_INTERVAL_TIME";
export const GETTER_LIMITED_COIN_INTERVAL_TIME =
  "GETTER_LIMITED_COIN_INTERVAL_TIME";
export const UPDAE_LIMITED_COIN_BUBBLE_STATUS =
  "UPDAE_LIMITED_COIN_BUBBLE_STATUS";
export const GETTER_LIMITED_COIN_BUBBLE_STATUS =
  "GETTER_LIMITED_COIN_BUBBLE_STATUS";
export const UPDATE_SUPER_PAY_RECOMMEND_CLICK_DATE =
  "UPDATE_SUPER_PAY_RECOMMEND_CLICK_DATE";
export const GETTER_SUPER_PAY_RECOMMEND_CLICK_DATE =
  "SUPER_PAY_RECOMMEND_CLICK_DATE";

export const UPDATE_SUPER_PAY_BUBBLE_STATUS = "UPDATE_SUPER_PAY_BUBBLE_STATUS";
export const UPDATE_SUPER_PAY_BUBBLE_SHOW_DATE =
  "UPDATE_SUPER_PAY_BUBBLE_SHOW_DATE";
export const GETTER_SUPER_PAY_BUBBLE_STATUS = "GETTER_SUPER_PAY_BUBBLE_STATUS";
export const GETTER_SUPER_PAY_BUBBLE_SHOW_DATE =
  "GETTER_SUPER_PAY_BUBBLE_SHOW_DATE";
export const GETTER_SUPER_PAY_BUBBLE_CLICK = "GETTER_SUPER_PAY_BUBBLE_CLICK";
export const UPDATE_SUPER_PAY_BUBBLE_CLICK_STATUS =
  "UPDATE_SUPER_PAY_BUBBLE_CLICK_STATUS";
export const SHOW_REDIRECT_SUPER_PAY = "SHOW_REDIRECT_SUPER_PAY";
export const START_PURCHASE_VIP_BACK_PROCESS =
  "START_PURCHASE_VIP_BACK_PROCESS";
export const UPDATE_LOCAL_FILES = "UPDATE_LOCAL_FILES";

/*
 * 订阅相关的配置
 * */
export const GETTER_SUBS_SETTING = "GETTER_SUBS_SETTING";
export const UPDATE_SUB_SETTING = "UPDATE_SUB_SETTING";

/*
 * 获取当前有效的推荐app
 * */
export const SELECT_APP_STATE = "SELECT_APP_STATE";
export const REQUEST_APP_STATE = "REQUEST_APP_STATE";
export const GETTER_UNINSTALLED_APP = "GETTER_UNINSTALLED_APP";
export const UPDATE_UNINSTALLED_LIST = "UPDATE_UNINSTALLED_LIST";

export const SHAKE_PLAY = "SHAKE_PLAY";
export const FETCH_VIDEO_URL_BY_DICT = "FETCH_VIDEO_URL_BY_DICT";

export const UPDATE_STATE_FRONT = "UPDATE_STATE_FRONT";
export const GETTER_STATE_FRONT = "GETTER_STATE_FRONT";

export const GETTER_IS_REDIRECT = "GETTER_IS_REDIRECT";
export const GETTER_HAS_REDIRECT = "GETTER_HAS_REDIRECT";
